import { useNavigate } from "react-router-dom";
import { depositDeclarationPath } from "./depositDeclarationModel";
import "./depositDeclaration.css";

export function DepositHistoryStatus({ row, badgeClassName, onOpen, confirmTo, showConfirmButton = true }) {
  const navigate = useNavigate();
  if (!row) return null;
  return (
    <span className="dd-statusStack">
      <span className={`${badgeClassName || ""}${row.needsSenderConfirm ? " dd-badgeLiteral" : ""}`}>
        {row.action}
      </span>
      {/* Table rows hide this. The deposit details popup still passes showConfirmButton. */}
      {showConfirmButton && row.needsSenderConfirm ? (
        <button
          type="button"
          className="dd-confirmBtn"
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            onOpen?.();
            navigate(confirmTo || depositDeclarationPath(row.id));
          }}
        >
          Confirm sender
        </button>
      ) : null}
    </span>
  );
}
